const INF = 1e9 + 5;
const MIN = Math.min();
const MAX = Math.max();
const MOD = 1e9 + 7;
const MAX_DESC_LEN = 50;
const MAX_CHHAR_PER_LINE = 15;
const MAXN = 500;
const TRANSACTIONS_MAX_AMOUNT = 5000;
let CURRENCY_SYMBOL = "$";

String.prototype.replaceAt = function(index, replacement, multiple = false) {
    return this.substr(0, index) + replacement+ this.substr(index + multiple ? replacement.length : 1);
};
